const trackingUtils = require('../modules/utils/tracking.utils');
const tagManagement = require('../modules/utils/tag_management.utils');
const membershipPasswordSetupPageFactory = require('components/membership/membership_password_setup_page/js/main');
const membershipAdvantagesFactory = require('components/membership/membership_advantages/js/main');
const membershipPasswordSetupFactory = require('components/membership/membership_password_setup/js/main');
const membershipCustomerServiceHotlineFactory = require('components/membership/membership_customer_service_hotline/js/main');
const membershipAppDownloadFactory = require('components/membership/membership_app_download/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');

const pageSetup = (pageName, pageClass) => {
    $('#page').removeClass().addClass(`${pageName} ${pageClass}`);
    Odigeo.Session.set('page', pageName);
    Odigeo._.extend(Odigeo.Model.prototype, {
        error500() {},
    });
};

const trackingSetup = (pageHash) => {
    trackingUtils.trackPage(pageHash, {funnel: false});
    tagManagement.updateDatalayer();
};

Odigeo.Router.handlers.membership_password_setup = function() {
    const pageName = 'membership_password_setup';
    const pageClass = 'od-prime-onboarding';
    const pageHash = 'prime/onboarding';

    const widgetLoader = createWidgetLoader({
        membershipPasswordSetupPage: ['membership-password-setup-page', membershipPasswordSetupPageFactory],
        membershipAdvantages: ['membership-advantages', membershipAdvantagesFactory],
        membershipPasswordSetup: ['membership-password-setup', membershipPasswordSetupFactory],
        membershipCustomerServiceHotline: ['membership-customer-service-hotline', membershipCustomerServiceHotlineFactory],
        membershipAppDownload: ['membership-app-download', membershipAppDownloadFactory],
    });

    const asyncWidgets = Odigeo.autoloadWidgetsAsync({
        getMembershipManager: ['membership-manager', 'membership_manager'],
        getUsersManager: ['users-manager', 'usersmanager'],
    });

    Odigeo.Router.eventController = $.extend(true,
        Odigeo.Router.eventController,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.handlers.userEventController,
        {
            globalEvents: {},
            viewEvents: {
                'membership-password-setup-page:getTokenInfo': 'onGetTokenInfo',
                'membership-manager:getTokenInfoOk': 'onGetTokenInfoOk',

                'membership-password-setup-page:renderPasswordSetup': 'onRenderPasswordSetup',
                'membership-password-setup:submitUserRequest': 'onSubmitUserRequest',

                'users-manager:changePasswordWithCodeOk': 'onChangePasswordSuccess',
                'users-manager:changePasswordWithCodeWithError': 'onChangePasswordWithError',
                'users-manager:changePasswordWithCodeError': 'onChangePasswordWithError',

                'membership-app-download:track': 'onTrackEvent',
                'membership-password-setup:track': 'onTrackEvent',
                'membership-customer-service-hotline:track': 'onTrackEvent',
            },
            eventHandlers: {
                onGetTokenInfo(token) {
                    asyncWidgets.getMembershipManager().execute('getTokenInfo', token);
                },
                onGetTokenInfoOk(info) {
                    widgetLoader.get('membershipPasswordSetupPage').execute('setTokenInfo', info);
                    widgetLoader.get('membershipAdvantages');
                    widgetLoader.get('membershipCustomerServiceHotline');
                    widgetLoader.get('membershipAppDownload');
                },

                onRenderPasswordSetup(info) {
                    widgetLoader.get('membershipPasswordSetup').execute('renderWidget', info);
                },

                onSubmitUserRequest(data) {
                    asyncWidgets.getUsersManager().execute('submitUserRequest', data);
                },

                onChangePasswordSuccess(data) {
                    widgetLoader.get('membershipPasswordSetup').execute('passwordChangedOk', data);
                },

                onChangePasswordWithError(data) {
                    widgetLoader.get('membershipPasswordSetup').execute('passwordWithError', data);
                },

                onTrackEvent(data) {
                    widgetLoader.get('membershipPasswordSetupPage').execute('track', data);
                },
            },
        }
    );

    pageSetup(pageName, pageClass);
    trackingSetup(pageHash);

    // Initialize
    Odigeo.Router.eventController.execute();
    Odigeo.Utils.sessionTimer.reset();

    widgetLoader.get('membershipPasswordSetupPage');
};
